var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-window',_vm._b({ref:"window",staticClass:"fwindow-width-5",attrs:{"title":`${_vm.$t('redeem')} ${_vm.token.name}`,"closing-disabled":_vm.windowDisabled}},'a-window',_vm.$attrs,false),[_c('nft-redeem',{attrs:{"token":_vm.token},on:{"transaction-status":_vm.onTransactionStatus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }